import Profile from "../../models/Users/Profile";
import state from '../../store/main/state'
import {PROFILE_FIELD_WITH_TAGS} from "@api/models/UserProfile";

const fetchProfiles = (userIds) => {
    return state.client
        .post('/objects/UserProfiles/query', {
            take: -1,
            include: PROFILE_FIELD_WITH_TAGS,
            where: {
                'userId': {'$in': userIds}
            }
        }).then(({data}) => {
            const items = data || [];
            return items.map(item => new Profile(item));
        });
};

const fetchProfile = (id, fieldName) => {
    return state.client
        .post('/objects/UserProfiles/query', {
            take: -1,
            include: PROFILE_FIELD_WITH_TAGS,
            where: {
                [fieldName]: id
            }
        }).then(({ data }) => {
            return data ? new Profile(data[0]) : null;
        });
}

const fetchProfileByUserId = (userId) => {
    return fetchProfile(userId, 'userId');
};

const fetchProfileById = (id) => {
    return fetchProfile(id, 'id');
};

const searchProfile = (query = {}) => {
    query['include'] = PROFILE_FIELD_WITH_TAGS;

    return state.client.post('/objects/UserProfiles/query', query)
        .then(({data}) => {
            const items = data || [];
            return items.map(item => new Profile(item));
        });
};

export {
    fetchProfiles,
    fetchProfileByUserId,
    fetchProfileById,
    searchProfile
}
